
  import { defineComponent, computed } from 'vue';
  import { InspectionActivity } from '@/entities/activity/model';
  import { CreatedAt } from '@/ui/components/activityLogs/common/CreatedAt';
  import { t } from '@/ui/i18n/i18n';
  import { boldifyStringArray } from '@/ui/components/activityLogs/helpers';

  interface ApprovalDeletedProps {
    resourceName: string;
    log: InspectionActivity;
  }

  export default defineComponent<ApprovalDeletedProps>({
    name: 'ApprovalDeleted',
    components: {
      CreatedAt,
    },
    props: ['resourceName', 'log'],
    setup(props) {
      const previousStatus = String(props.log.payload?.previous_status || '')
        .replace(/_/g, '-');
      const message = previousStatus
        ? t(`approval.status.${previousStatus}`)
        : '';

      const activityMessage = computed(() => {
        return t('activity-logs.approval-reset', {
          username: boldifyStringArray([props.log.user!.name]),
          status: message,
        });
      });

      return {
        activityMessage,
      };
    },
  });
